module.exports = __webpack_public_path__ + "img/4112214df8f69178a7fb8eaf45a43250.png";